export default __webpack_public_path__ + "static/media/danskeheadlinebold-webfont.0a001f0c.eot";